import { prefixObjectValues } from '../../utils';
const form = {
  title: 'title',
  providerCategory: 'provider-category',
  specialty: 'specialty',
  subspecialties: 'subspecialties',
  renewable: 'renewable',
  startDate: 'start-date',
  endDate: 'end-date',
  numOfFtes: 'num-of-ftes',
  fteShiftsPerYear: 'fte-shifts-per-year',
  hoursPerShift: 'hours-per-shift',
  totalShifts: 'total-shifts',
  totalHours: 'total-hours',
  compType: 'comp-type',
  avgBaseHourlyRate: 'avg-base-hourly-rate',
  avgRateWithDiff: 'avg-rate-with-diff',
  totalContractValue: 'total-contract-value',
  weekdayShifts: 'weekday-shifts',
  weekendShifts: 'weekend-shifts',
  holidayShifts: 'holiday-shifts',
  diffCost: 'diff-cost',
  feeDisclaimer: 'fee-disclaimer',
};
export default prefixObjectValues(form, 'review-info');
